export default __webpack_public_path__ + "static/media/logoText.f9f7dba7.svg";